
<form class="row row-gap-2 mb-3 page_card__wide">
    <div class="col-3 position-relative">
        <fs-company-select [formField]="deviceFilter.aziendaId" />
    </div>
    <div class="col-3">
        <fs-contract-select [formField]="deviceFilter.codiceContratto" [company]="deviceFilter.aziendaId().value()" />
    </div>
    <div class="col-3 position-relative">
        <fs-asset-type-select [formField]="deviceFilter.assetTypeId"/>
    </div>
    <div class="col-3 position-relative">
        <fs-vendor-select [formField]="deviceFilter.assetVendorId" [assetTypeId]="deviceFilter.assetTypeId().value()" />
    </div>
    <div class="col-3 position-relative">
        <fs-model-select [formField]="deviceFilter.assetModel" [assetVendorId]="deviceFilter.assetVendorId().value()" />
    </div>
    <div class="col-3">
        <label for="imeiFilter" class="form-label">IMEI</label>
        <input id="imeiFilter" type="text" class="form-control" [formField]="deviceFilter.imei" />
    </div>
    <div class="col-3">
        <label for="startDateFilter" class="form-label">Data di inizio noleggio</label>
        <div class="input-group">
            <input
                id="startDateFilter"
                type="text"
                class="form-control"
                ngbDatepicker
                #startRentPicker="ngbDatepicker"
                [formField]="deviceFilter.dataInizioServizio"
                dateInput
            />
            <button type="button" class="btn btn-outline-secondary" (click)="startRentPicker.toggle()">
                <span class="material-symbols-outlined">edit_calendar</span>
            </button>
        </div>
    </div>
    <div class="col-3">
        <label for="endDateFilter" class="form-label">Data di fine noleggio</label>
        <div class="input-group">
            <input
                id="endDateFilter"
                type="text"
                class="form-control"
                ngbDatepicker
                #endRentPicker="ngbDatepicker"
                [formField]="deviceFilter.dataFineServizio"
                [dateInput]="{ endOfDay: true }"
            />
            <button type="button" class="btn btn-outline-secondary" (click)="endRentPicker.toggle()">
                <span class="material-symbols-outlined">edit_calendar</span>
            </button>
        </div>
    </div>
    <div class="col-3">
        <label for="rentCodeFilter" class="form-label">Codice Noleggio</label>
        <input id="rentCodeFilter" type="text" class="form-control" [formField]="deviceFilter.codiceNoleggio" />
    </div>
    <div class="col-3">
        <label for="rentStatusFilter" class="form-label">Stato Noleggio</label>
        <select id="rentStatusFilter" class="form-select" [formField]="deviceFilter.statoNoleggio">
            <option value="">Tutti i tipi</option>
            <option value="ATTIVO">Attivo</option>
            <option value="CESSATO">Cessato</option>
        </select>
    </div>
    <div class="col-12 d-flex justify-content-end">
        <button type="button" class="btn btn-sm btn-outline-primary" (click)="resetFilters()">
            <span class="material-symbols-outlined align-middle">filter_alt_off</span>
            Reset filtri
        </button>
    </div>
</form>

<div class="row page_card__wide">
    <div class="col-12" [spinnerLoader]="deviceResource.isLoading()">
        <div class="table-responsive">
            <table class="table align-middle">
                <thead>
                    <tr>
                        <th scope="col">Noleggio</th>
                        <th scope="col">IMEI</th>
                        <th scope="col">Dispositivo</th>
                        <th scope="col">Contratto</th>
                        <th scope="col">Inizio noleggio</th>
                        <th scope="col">Fine noleggio</th>
                        <th scope="col">Stato</th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    @for (item of deviceResource.value()?.content; track $index) {
                        <tr>
                            <td>
                                {{item.codiceNoleggio}}
                                <small class="text-muted d-block">{{item.servizioSuApparato}}</small>
                            </td>
                            <td><span class="text-muted">{{item.imei}}</span></td>
                            <td>
                                {{item.modello}}
                                <small class="text-muted d-block">{{item.assetVendor}} &#x2022; {{item.descrizioneApparato}}</small>
                            </td>
                            <td>{{item.codiceContratto}}</td>
                            <td>{{item.dataInizioServizio | compactDate: 'dd/MM/yyyy'}}</td>
                            <td>{{item.dataFineServizio | compactDate: 'dd/MM/yyyy'}}</td>
                            <td>
                                <span class="badge" [ngClass]="{'bg-warning-subtle text-warning': item.statoNoleggio === 'CESSATO', 'bg-success-subtle text-success': item.statoNoleggio === 'ATTIVO'}">&#x2022; {{item.statoNoleggio}}</span>
                            </td>
                            <td>
                                <button type="button" class="btn" [routerLink]="['../', item.imei]">
                                    <span class="material-symbols-outlined text-muted">chevron_right</span>
                                </button>
                            </td>
                        </tr>
                    } @empty {
                        <tr>
                            <td colspan="8" class="text-center">Nessun risulato</td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>

        <pagination [paginationData]="paginationData" />
    </div>
</div>
